<template>
  <div id="app">
    <div class="page-container">
      <cz-header :scroll-top="scrollTop"></cz-header>
      <contact/>
      <router-view :scroll-top="scrollTop"></router-view>
      <cz-footer></cz-footer>
    </div>
  </div>
</template>

<script>
import czHeader from '@/components/base/cz-header/cz-header.vue';
import czFooter from '@/components/base/cz-footer/cz-footer.vue';
import Contact from '@/components/base/contact/contact.vue';
export default {
  components: {
    czHeader,
    czFooter,
    Contact
  },
  name: 'App',
  data() {
    return {
      scrollTop: 0
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.scrollTop = scrollTop;
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>
